import React from 'react';
import { Form, Select, Input } from 'antd';
import { tables, fields, aggregations } from 'shared/constants/results';
import { shouldUpdateDependency } from 'components/FormDependency';
import useFormatMessage from 'hooks/useFormatMessage';
import messages from './messages';
import MetricDisplayConfig from './MetricDisplayConfig';

const MetricConfig = ({ metrics }) => {
  const $t = useFormatMessage();
  return (
    <>
      <Form.Item label="Name" name="name" rules={[{ required: true, message: 'Name is required' }, { pattern: /^[a-zA-Z0-9]+$/, message: 'Name can only contain letters, numbers' }]}>
        <Input />
      </Form.Item>
      <Form.Item label="Label" name="label" rules={[{ required: true, message: 'Label is required' }]}>
        <Input />
      </Form.Item>
      <Form.Item label="Dataset" name="table">
        <Select
          showSearch
          options={Object.entries(tables).map(([t]) => ({
            label: messages[t] ? $t(messages[t]) : t,
            value: t,
          }))}
        />
      </Form.Item>
      <Form.Item noStyle shouldUpdate={shouldUpdateDependency(['table'])}>
        {({ getFieldValue }) => {
          const table = getFieldValue('table');
          return (
            <Form.Item label="Field" name="field">
              <Select
                options={Object.entries(fields).filter(([, field]) => field.table === table).map(([f]) => ({
                  label: messages[f] ? $t(messages[f]) : f,
                  value: f,
                }))}
                showSearch
              />
            </Form.Item>
          );
        }}
      </Form.Item>

      <Form.Item label="Aggregation" name="aggregation">
        <Select options={aggregations} />
      </Form.Item>
      <MetricDisplayConfig namePath={['displayConfig']} metrics={metrics} />
    </>
  );
};

export default MetricConfig;
